import { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { PAYMENT_OPTIONS, LOCALSESSIONDATAKEYS, SIGNUPTYPE } from "../../../../constants/AppConstants";
import { useDispatch } from "react-redux";
import { ZuoraPaymentInfoRendering } from "../../../../actions/MyAccount";
import { paymentOptionsNameTranslation } from "../../../../constants/AppMethod";
import ZuoraPaymentForm from "../ZuoraPaymentForm";
import { useTranslation } from "react-i18next";
import { getLocalSessionData, setLocalSessionData } from "../../../../utils/Authentication/handleUserSession";

const PaymentOptionsTab = (props) => {
    const { t } = useTranslation(['translation']);
    const { cname = 'none', paymentOptions, zrenderParams, signUpType, paymentMethod } = props;
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState((paymentMethod) ? paymentMethod : PAYMENT_OPTIONS.CREDIT_CARD);
    const [tabContents, setTabContents] = useState({ [PAYMENT_OPTIONS.CREDIT_CARD]: (paymentMethod && paymentMethod === PAYMENT_OPTIONS.DIRECT_BANK_TRANSFER) ? false : true, [PAYMENT_OPTIONS.DIRECT_BANK_TRANSFER]: (paymentMethod && paymentMethod === PAYMENT_OPTIONS.DIRECT_BANK_TRANSFER) ? true : false, [PAYMENT_OPTIONS.GOOGLE_PAY]: (paymentMethod && paymentMethod === PAYMENT_OPTIONS.GOOGLE_PAY) ? true : false });
    const signUpTypefromLocal = getLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE)
    const handlePaymentOptions = (paymentType) => {
        if (paymentType === activeTab) {
            setActiveTab(paymentType);
            setLocalSessionData(LOCALSESSIONDATAKEYS.PAYMENT_OPTION, paymentType);
        } else {
            setActiveTab(paymentType);
            setLocalSessionData(LOCALSESSIONDATAKEYS.PAYMENT_OPTION, paymentType);
            setTabContents(
                Object.fromEntries(Object.entries(tabContents).map(([key, val]) => {
                    return [key, (key === paymentType) ? true : false];
                }))
            );
            if (paymentType !== PAYMENT_OPTIONS.GOOGLE_PAY)
                dispatch(ZuoraPaymentInfoRendering(paymentType));
        }
    }
    return (
        <div id="payment-options-tab" className={`payment-options-comp payment-options-tab-wrapper zuora-payment-wrapper ${cname}`}>
            <h2>{t('PAYMENT_OPTIONS.SELECT_PAYMENT_METHOD')}</h2>
            <div className="payment-option-tab-btn-container tabs-section">
                <div id="payment-options-tab-btns" className="tab-btn-wrapper">
                    <Nav tabs>
                        {
                            paymentOptions.data.length > 0 && paymentOptions.data
                                .filter(val => val.paymentMethodName !== PAYMENT_OPTIONS.GOOGLE_PAY)
                                .filter(val => {
                                    if (signUpTypefromLocal === SIGNUPTYPE.HARDWARE_INCLUSIVE) {
                                         return val.paymentMethodName !== PAYMENT_OPTIONS.DIRECT_BANK_TRANSFER;
                                    }
									else 
									return true
                                })
                                .map((val) =>
                                    <NavItem key={val.paymentMethodName}>
                                        <NavLink active={activeTab === val.paymentMethodName} onClick={() => handlePaymentOptions(val.paymentMethodName)}>
                                            {paymentOptionsNameTranslation(val.paymentMethodName)}
                                        </NavLink>
                                    </NavItem>
                                )
                        }
                    </Nav>
                </div>
                <div className="payment-option-tab-content-wrapper">
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId={PAYMENT_OPTIONS.CREDIT_CARD}>
                            {zrenderParams.loading &&
                                <div className="payment-options-spinner-wrapper">
                                    <div className="spinner-border" role="status">
                                    </div>
                                </div>
                            }
                            {!zrenderParams.loading
                                && tabContents[PAYMENT_OPTIONS.CREDIT_CARD]
                                && <ZuoraPaymentForm signUpType={signUpType} paymentOptions={PAYMENT_OPTIONS.CREDIT_CARD} />
                            }
                        </TabPane>
                        {signUpTypefromLocal === SIGNUPTYPE.HARDWARE_INCLUSIVE ?   null :
                        
                            <TabPane tabId={PAYMENT_OPTIONS.DIRECT_BANK_TRANSFER}>
                                {zrenderParams.loading &&
                                    <div className="payment-options-spinner-wrapper">
                                        <div className="spinner-border" role="status">
                                        </div>
                                    </div>
                                }
                                {!zrenderParams.loading
                                    && tabContents[PAYMENT_OPTIONS.DIRECT_BANK_TRANSFER]
                                    && <ZuoraPaymentForm signUpType={signUpType} paymentOptions={PAYMENT_OPTIONS.DIRECT_BANK_TRANSFER} />
                                }
                            </TabPane>
}

                    </TabContent>
                </div>
            </div>
        </div>
    )
}

export default PaymentOptionsTab;